/* eslint-disable no-secrets/no-secrets */
import React, {  useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../Drone.module.scss';
import metadata from './RiskInformationComponent.metadata.json5';

function RiskInformationComponent(props) {

const { submissionVM, updateWizardData,pathUpdated} = props;
const breakpoint = useContext(BreakpointTrackerContext);
const { onValidate } = useValidation('RiskInformationComponent');
const modelVM = _.get(submissionVM, pathUpdated);

modelVM.value.isValidationReq = true;
modelVM.value.iherActTha = modelVM.value.iherActTha === true ? true : undefined;

// eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        doYouUseDroRecMor20: {
            visible: !_.isUndefined(modelVM.value.doYouUseDroForRec) 
            && modelVM.value.doYouUseDroForRec === true
        },
        BusinessInformationContainer: {
            visible: !_.isUndefined(submissionVM.value.baseData.accountHolder.subtype) 
            && submissionVM.value.baseData.accountHolder.subtype === 'Company'
        },
        busNamFie: {
            visible: !_.isUndefined(modelVM.value.comStrFie) 
            && modelVM.value.comStrFie === 'Bus'
        }
    };


const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM,pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            if(changedPath === 'iherActTha' && value === false) {
                value = undefined
            }

            _.set(submissionVM,`${fullPath}`,value);
            _.set(submissionVM,`${pathUpdated}.iHerAckThaItIsAConRulFie`,value);
            _.set(submissionVM,`${pathUpdated}.iHerAckThaItIsA1CoGuiFie`,value);
            _.set(submissionVM,`${pathUpdated}.iHerAckThaItIsA2CoKepFie`,value);
            _.set(submissionVM,`${pathUpdated}.iHerAckThaItIsA3CoExpFie`,value);

            updateWizardData(submissionVM);         
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={modelVM}
                // onModelChange={updateWizardData}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                onValueChange={handleValueChange}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
    );


}

RiskInformationComponent.propTypes = wizardProps;
export default withRouter(RiskInformationComponent);
